import type { CSSProperties } from "react";

/** Multi-line ellipsis : https://codefrontend.com/css-ellipsis/ */
export const multilineEllipsis = (lines: number): CSSProperties => ({
  overflow: "hidden",
  display: "-webkit-box",
  overflowWrap: "anywhere",
  hyphens: "auto",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: lines,
});
